import { render, staticRenderFns } from "./SettingsTable.vue?vue&type=template&id=fc316036&scoped=true"
import script from "./SettingsTable.vue?vue&type=script&lang=ts"
export * from "./SettingsTable.vue?vue&type=script&lang=ts"
import style0 from "./SettingsTable.vue?vue&type=style&index=0&id=fc316036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc316036",
  null
  
)

export default component.exports